import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import {
    authUserSetCommentsColumnView
} from '../../../../../../../rest/effects/authUser/authUserSetCommentsColumnView';
import {
    getUserCommentsColumnView
} from '../../../../../../../store/model/authUser/selectors/getUserCommentsColumnView';
import { vent } from '../../../../../../../store/constants';
import { CLASS_ASIDE_PANEL, CLASS_ASIDE_PANEL_TRANSITION } from '../../../constants';
import { CLASS_CARD_DETAILS } from '../../../../cardDetails';
import { ASIDE_PANE_COMMENTS_COLUMN_ANIMATION } from '../../../components/AsidePanelCommentsColumnViewButton/constants';
import { getAsidePanelEntityPanelWidth } from '../../../store/selectors/getAsidePanelEntityPanelWidth';
import { getAsidePanel } from '../../../store/selectors/getAsidePanel';
import { ASIDE_COLUMN_MIN_WIDTH, GOOGLE_SPACING } from '../../../../../../../const';
import { CLASS_ASIDE_PANEL_BODY } from '../../../components/AsidePanelBody/constants';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../middlewares/segment';
import {
    SegmentCardOptionStatusValue,
    SegmentCardSourceValue
} from '../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onClick = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const asidePanel = document.querySelector('.' + CLASS_ASIDE_PANEL) as HTMLElement;
        if (!asidePanel) return;

        const state = getState();
        const isColumnView = getUserCommentsColumnView(state);
        dispatch(segmentTrackAction(SegmentCardEvent.COLUMN_TOGGLE, {
            name: SegmentCardOptions.STATUS,
            value: isColumnView ? SegmentCardOptionStatusValue.OFF : SegmentCardOptionStatusValue.ON,
        }, [
            {
                name: SegmentCardOptions.SOURCE,
                value: SegmentCardSourceValue.BUTTON,
            }
        ]));

        const onToggle = () => {
            const columnWidth = getAsidePanel(state).columnWidth || ASIDE_COLUMN_MIN_WIDTH;
            const asideWidth = getAsidePanelEntityPanelWidth(state);
            const transition = `all ${ASIDE_PANE_COMMENTS_COLUMN_ANIMATION}ms cubic-bezier(.23,1,.32,1)`;
            asidePanel.style.transition = transition;
            asidePanel.classList.add(CLASS_ASIDE_PANEL_TRANSITION);

            if (isColumnView) {
                const asideBody = document.querySelector(`.${CLASS_ASIDE_PANEL_BODY}`) as HTMLElement;
                const body = document.querySelector(`.${CLASS_CARD_DETAILS}__body`) as HTMLElement;
                const details = document.querySelector(`.${CLASS_CARD_DETAILS}__container`) as HTMLElement;
                const column = document.querySelector(`.${CLASS_CARD_DETAILS}__container-wrapper`) as HTMLElement;
                body.style.transition = transition;
                if (!details || !column) return;

                details.style.overflow = 'hidden';
                column.style.padding = '0';
                const isScrollVisible = document.documentElement.classList.contains('scroll-visible');
                const isMinimized = body.className.includes('--actions-minimized');
                const offset = GOOGLE_SPACING * (isMinimized ? 1.5 : 2.5);
                body.style.minWidth = `${body.offsetWidth - (isScrollVisible ? offset : 0)}px`; // scroll
                asidePanel.style.width = `${asidePanel.offsetWidth - columnWidth + (isScrollVisible ? 0 : offset)}px`; // scroll
                asideBody.classList.remove(CLASS_ASIDE_PANEL_BODY + '--columns');
                setTimeout(() => {
                    column.style.opacity = '0';
                    dispatch(authUserSetCommentsColumnView(!isColumnView));
                    requestAnimationFrame(() => {
                        vent.trigger(vent['view:resized']); // to setPanelsWidth
                        setTimeout(() => {
                            asidePanel.style.transition = 'unset';
                            details.style.overflow = 'auto';
                            asidePanel.classList.remove(CLASS_ASIDE_PANEL_TRANSITION);
                        }, 0);
                    });
                }, ASIDE_PANE_COMMENTS_COLUMN_ANIMATION);
            } else {
                asidePanel.style.maxWidth = `${asidePanel.offsetWidth}px`;
                dispatch(authUserSetCommentsColumnView(!isColumnView));
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        const body = document.querySelector(`.${CLASS_CARD_DETAILS}__body`) as HTMLElement;
                        if (!body) return;
                        body.style.transition = transition;
                        body.style.minWidth = `${columnWidth + asideWidth}px`; // scroll
                        requestAnimationFrame(() => {
                            vent.trigger(vent['view:resized']); // to setPanelsWidth
                            asidePanel.style.maxWidth = 'unset';
                            setTimeout(() => {
                                asidePanel.style.transition = 'unset';
                                body.style.transition = 'unset';
                                body.style.minWidth = 'unset';
                                asidePanel.classList.remove(CLASS_ASIDE_PANEL_TRANSITION);
                            }, ASIDE_PANE_COMMENTS_COLUMN_ANIMATION);
                        });
                        observer.disconnect();
                    });
                });
                const cardDetails = document.querySelector(`.${CLASS_CARD_DETAILS}`) as HTMLElement;
                if (cardDetails) {
                    observer.observe(cardDetails, { childList: true, subtree: true });
                }
            }
        };

        const isNoHeader = document.querySelector(`.${CLASS_ASIDE_PANEL}--without-header`) as HTMLElement;
        if (isNoHeader && !isColumnView) {
            const asidePanel = document.querySelector('.' + CLASS_ASIDE_PANEL_BODY) as HTMLElement;
            asidePanel.scrollTop = 0;
            setTimeout(() => { // ждем пока проскролимся вверх
                onToggle();
            }, 200);
        } else {
            onToggle();
        }
    };
    return action;
};
